var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon51(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,12.8l-9.1,9.1C57.6,20.6,53.9,20,50,20c-22.1,0-33.3,20.9-37.1,29.7c1.5,3.2,4,8,7.6,12.8L12,71.1 C3.8,60.5,0,50,0,50S13,8,50,8C57.8,8,64.5,9.8,70.2,12.8z M50,32c-9.9,0-18,8.1-18,18c0,0.3,0,0.7,0,1l19-19C50.7,32,50.3,32,50,32 z M68,49L49,68c0.3,0,0.7,0,1,0c9.9,0,18-8.1,18-18C68,49.7,68,49.3,68,49z M88.5,28.5l-8.6,8.6c3.5,4.8,5.8,9.5,7.2,12.7 c-1.6,3.4-4.4,8.7-8.5,13.9C70.2,74.5,60.6,80,50,80c-3.9,0-7.6-0.8-10.9-2.1l-9.1,9C35.8,90,42.4,92,50,92c34.9,0,50-42,50-42 S96.7,39.1,88.5,28.5z M99.8,5.8l-5.7-5.7l-94,94l5.7,5.7L99.8,5.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon51);
export default __webpack_public_path__ + "static/media/motion_icon-51.6ec32386.svg";
export { ForwardRef as ReactComponent };